// extracted by mini-css-extract-plugin
export var gridWrapper = "imageGrid-module--gridWrapper--83c8d";
export var image = "imageGrid-module--image--71606";
export var imageGrid = "imageGrid-module--imageGrid--98ccd";
export var text = "imageGrid-module--text--db9d2";